var api = "https://api.qingcigame.com";
// var api =  "https://api.qcplay.com";
var videoList = []
var artList = []
var swiper4 = null
var imgIndex = 0
var videoIndex = 0
var pageIndex = 1
let tColor = ''
var initialSlide = 0;
var change = true;

var obj = {
    index: function() {
        function getRequest() {
            var query = window.location.search;
            if (query.indexOf("?") != -1) {
                var str = query.substring(1);
                var strs = str.split("=");
                if (strs[1] == 1) {
                    initialSlide = 1;
                } else if (strs[1] == 2) {
                    initialSlide = 2;
                } else if (strs[1] == 3) {
                    initialSlide = 3;
                } else if (strs[1] == 4) {
                    initialSlide = 4;
                }
            }
        };
        getRequest(); //二级页面导航栏跳转
        this.preloading(); // 预加载
        this.indexAjax(); // 首页数据
        this.indexSwiper(); // 首页大轮播
        // this.newsShow(); // 首页最新新闻展示
        this.indexBind(); // 首页按钮
        this.wikiShow(); //贵重品展示
        this.wikiPopup(); //贵重品弹窗
        this.wikiTabInfo(); //贵重品弹窗内信息切换
        this.mapPopup(); //地图探索弹窗
        this.share(); // 分享链接
        this.urlAjax(); //社媒平台链接合集
        this.countNum(); //阿里云埋点
        // this.Textlength(28, 25);    // 内容字体长度超过40，标题字体长度超过25
    },
    // 图片资源预加载
    preloading: function() {
        //图片预加载
        var queue = new createjs.LoadQueue();
        var _this = this;
        queue.on("progress", function(e) {
            //加载中的进度
            //加载中的进度
            if (e.progress * 100 >= 10) {
                $(".loding_time span").width(parseInt(e.progress * 100) + '%')
            };
            var numbers = e.progress * 100;
        }, this);
        queue.on("complete", function(e) {
            //加载完成执行操作
            $('.loding_time').remove();
            $('.preloading').addClass('preloading-ani').fadeOut(500);
            $('.index').addClass('index-show');
            _this.indexSwiper();
            // $('.recommend-popup').fadeIn();     // 新增加弹窗
            setTimeout(function() {
                $('.preloading').remove();

            }, 500)
        }, this);
        queue.loadManifest([
            //加载图片，不包括后台的
            '/official/images/mobile/m_jdt-0fe07a342f.png',
            '/official/images/mobile/m_dt_t-8682607187.png',
            '/official/images/mobile/m_dt_sz-4bd8caac4f.png',
            '/official/images/mobile/index_content_title-3b0ebdd0f5.png',
            '/official/images/mobile/index_content_bg_01-b15f410abc.jpg',
            '/official/images/mobile/index_content_bg_02-b777c822e4.png',
            '/official/images/mobile/index_content_bg_03-4222eebac5.png',
            '/official/images/mobile/index_content_bg_04-c2f4d87515.png',
            '/official/images/mobile/index_content_bg_05-64c77b2081.png',
            '/official/images/mobile/index_content_title_02-9d20e4d163.png',
            '/official/images/mobile/index_content_title_03-14e1aaab82.png',
            '/official/images/mobile/index_content_title_04-06bdd72a91.png',
            '/official/images/mobile/index_content_title_05-ff46bdf9b4.png',
            '/official/images/mobile/btn_03-b69fff62eb.png',
            '/official/images/mobile/btn_down-ecfb2aee7c.png',
            '/official/images/mobile/btn_more-7b669a2644.png',
            '/official/images/mobile/video_btn-4c3f1c54fc.png',
            '/official/images/mobile/map_explore-9aad7b8cb8.png',
        ]);
    },
    // 首页最新新闻展示
    newsShow: function() {
        const loadKey = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        var limit = 5;
        $.ajax({
            // url: "//api.qcplay.com/web/article" + "?limit=" + limit + "",
            url: "//api.qingcigame.com/west/new/list" + "?limit=" + limit + "",
            type: "GET",
            data: {
                area_id: 2
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    // 新闻顶部banner
                    $(".content-02 .banner img").attr("src", json.data.data[0].thumbnail);
                    // $(".content-02 .banner a").attr("href", `news-details.html?id=' ${json.data.data[0].}`);

                    // 渲染列表
                    $.each(json.data.data, function(index, values) {
                        var lnHtml = '<li>' +
                            '<a title="' + values.article_title + '" href="news-details.html?id=' + values.id + '">' +
                            '<p>' + values.article_title + '</p>' +
                            '<span>' + values.release_time + '</span>' +
                            '</a>' +
                            '</li>';
                        $('.latest-news').append(lnHtml);
                        _this.maxLength(".latest-news p", 30);
                    });
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(loadKey);
            }
        })
    },
    // 新闻列表
    newsList: function() {
        var cate_id, page, current, index, urls;
        // &limit=1
        var urls = '//api.qingcigame.com/west/new/list'; // 第一页
        // var page = 1;
        this.hiddenNav(); // 头部隐藏导航
        this.newsZxList(urls); // 新闻最新列表
        this.newsTabPage(); // 新闻导航切换
    },
    // 游戏攻略列表
    intrList: function() {
        var cate_id, page, current, index, urls;
        // &limit=1
        var urls = '//api.qingcigame.com/west/new/list?page=1'; // 第一页
        this.hiddenNav(); // 头部隐藏导航
        this.newsIntrList(urls); // 新闻最新列表
        this.newsTabPage(); // 新闻导航切换
    },
    // 新闻详情
    newsDetails: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.newsInfo(); // 新闻详情
        this.footShare(); // 尾部分享
    },
    // 视频中心
    videoCenter: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.videoSwitch(); // 新闻导航切换
        this.videoCenterAjax(); // 获取视频中心视频
    },
    // 视频详情
    videoDetails: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.videoDetailsAjax(); // 获取详细的视频
        this.footShare(); // 尾部分享
    },
    // 同人专区
    colleagues: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.worksAjax(); // 同人专区-作品
        this.videoSwitch(); // 全部、同人绘、手作
    },
    // 同人专区-作品详情
    drawingDetails: function() {
        this.hiddenNav(); // 头部隐藏导航
        this.drawingInfo(); // 获取数据
        this.footShare(); // 尾部分享
    },
    // wiki首页
    wikiIndex: function() {
        this.hiddenNav(); // 头部隐藏导航
        // this.wikiSwiper(); // 轮播
        this.wikiIndexAjax();
    },
    // wiki-贵重物品
    wikiPrecious: function() {
        var rarity, deviation, deviation, mosaic_skill, halo_effect, column, order, page, url;
        // this.getWikiData(); // 获取筛选的参数
        this.wikibind(); // wiki绑定事件
        this.filtering(); // wiki-贵重物品-筛选
        this.wikiSearch(); // wiki-贵重物品-搜索
        this.wikiTabInfo(); // tab切换信息
        this.wikiPopup(); // 弹窗的开关查看详情
        this.preventInput(); // 阻止页面弹起
        this.hiddenNav(); // 头部隐藏导航
    },
    // 首页提示
    indexBind: function() {
        $('.monitor-btn').on('click', function() {
                var mon_btn = $(this).attr('data-event');
                obj.countNum(mon_btn);
                //obj.countNum('mon_btn');
            })
            // 视频播放
        var Media = document.getElementById('media-play');

        $('.videos-btn').on('click', function(event) {
            var _this = $(this)
            var data = _this.attr('data');
            $('.popup').fadeIn().find('video').attr('src', data);
            var playPromise = Media.play();

            if (playPromise !== undefined) {
                playPromise.then(_ => {
                    // 这个时候可以安全的暂停
                    Media.pause();
                }).catch(error => {

                })
            }
        });

        $('.video-btn').on('click', function(event) {
            var data = $(this).attr('data');
            $('.popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        // 关闭视频
        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();
        });

        // MEDIA 图片弹窗
        $('.art img').on('click', function() {
            var imgSrc = $(this).attr('src');
            $('.img-popup').fadeIn().find('img').attr('src', imgSrc);
        });

        $('.title .play-btn, .role-info').click(function(event) {
            layer.msg("暂未开放，敬请期待!", { time: 2000 });
        });

        $('.recommend-popup').on('click', '.close-btn', function(event) {
            $('.rec-box').addClass('hide-ani')
            $('.recommend-popup').fadeOut();
        });

        // 播放视频
        $('.swiper-container-video').on('click', '.swiper-slide', function(event) {
            var data = $(this).attr('data');
            $('.popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        $('.videos').on('click', 'a', function(event) {
            var data = $(this).attr('data');
            $('.popup').fadeIn().find('video').attr('src', data);
            Media.play();
        });

        $('.close-btn').click(function(event) {
            $('.popup').fadeOut().find('video').attr('src', '');
            Media.pause();
        });

        // 点击背景关闭弹窗
        $('.popup_wrap').click(function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup_wrap').fadeOut();
            }
        });

        // $('.app-btn').on('click', function() {
        //     layer.msg("Coming soon. Please stay tuned!", {
        //         time: 2000
        //     });
        // });

        // 下载按钮
        // $('.download-btn').click(function(event) {
        //     var game_id = 39;
        //     $.ajax({
        //         type: "get",
        //         url: 'https://mapi.qingcigame.com/get_url?game_id=' + game_id + '',
        //         dataType: 'json',
        //         xhrFields: {
        //             withCredentials: true
        //         },
        //         success: function(json) {
        //             console.log(json);
        //             // 微信
        //             var ua = navigator.userAgent.toLowerCase();
        //             if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //                 $('.download_wrap').fadeIn();
        //                 return
        //             };
        //             //安卓
        //             if (/(Android)/i.test(navigator.userAgent)) {
        //                 if (json.data.android_download_url == '') {
        //                     layer.msg('安卓下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
        //                 } else {
        //                     location.href = json.data.android_down_url
        //                         // console.log(json.data.android_down_url);
        //                 }
        //             };
        //             //ios
        //             if (/(iphone)/i.test(navigator.userAgent)) {
        //                 if (json.data.ios_download_url == '') {
        //                     layer.msg('ios下载暂未开放，敬请期待！<br/>详情请关注官方qq群：666341871', { time: 3000 });
        //                 } else {
        //                     location.href = json.data.ios_down_url
        //                         // console.log(json.data.ios_down_url);
        //                 }
        //             };
        //         }
        //     });
        // });
        $('.download-btn').click(function(event) {
            // 微信
            var ua = navigator.userAgent.toLowerCase();
            if (ua.match(/MicroMessenger/i) == "micromessenger") {
                $('.download_wrap').fadeIn();
                return
            };
            //安卓
            if (/(Android)/i.test(navigator.userAgent)) {
                var google_url = "//play.google.com/store/apps/details?id=com.qcplay.snail.android.na";
                location.href = google_url;
            };
            //ios
            if (/(iphone)/i.test(navigator.userAgent)) {
                var app_url = "//apps.apple.com/us/app/id6445937968";
                location.href = app_url;
                // layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
            };
        });

        // 关闭下载提示
        $('.download_wrap').on('click', function() {
            $('.download_wrap').fadeOut();
        });
    },
    // 首页接口请求
    indexAjax: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        $.ajax({
            // url: "https://api.qcplay.com/web/index",
            url: "//api.qingcigame.com/west/index",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                // var zonghe = json.data.articleList.zonghe;
                // var activity = json.data.articleList.activity;
                // var cartoon = json.data.articleList.cartoon;
                var video = videoList = json.data.articleList.video;
                // var jijie = json.data.articleList.jijie;
                // var museum = artList = json.data.articleList.museum;

                var news = json.data.articleList.news; //最新新闻
                var art = artList = json.data.articleList.art; //媒体 图片

                if (json.code == 200) {
                    // 新闻顶部banner
                    $(".content-02 .banner img").attr("src", news[0].thumbnail);
                    $(".content-02 .banner a").attr("href", `news-details.html?id=${news[0].id}`);

                    // 渲染列表
                    $.each(news, function(index, values) {
                        var lnHtml = '<li>' +
                            '<a title="' + values.article_title + '" href="news-details.html?id=' + values.id + '">' +
                            '<p>' + values.article_title + '</p>' +
                            '<span>' + values.release_time + '</span>' +
                            '</a>' +
                            '</li>';
                        $('.latest-news').append(lnHtml);
                        _this.maxLength(".latest-news p", 30);
                    });
                    // $.each(news, function(index, values) {
                    //     var newsHtml = `<div class="swiper-slide">
                    //     <a href="news-details.html?id=${values.id}">
                    //     <img src="${values.thumbnail}">
                    //     <span></span>
                    //     <div>
                    //     <p>${values.article_title}</p>
                    //     </div>
                    //     </a></div>`;
                    //     $('.swiper-container-new .slideTxtBox-box').append(newsHtml);
                    // });

                    // 新闻标题限制字数
                    // $('.swiper-container-news .slideTxtBox-box p').each(function() {
                    //     if ($(this).text().length > 50) {
                    //         var str = $(this).text();
                    //         $(this).text(str.substr(0, 50) + '...');
                    //     }
                    // });

                    // media 初始化 展示的图片
                    $(".media-box img").attr("src", art[0].thumbnail);
                    // 视频合集暂未开放
                    $(".videos img").attr("src", video[0].thumbnail);
                    $(".videos a").attr("data", video[0].video_link);

                    // 视频合集暂未开放
                    // $(".videos img").attr("src", 'https://download4.qcplay.com/qcgame-admin/TvjMu5U715JlCqsQgJukLapqXhakTxoY4GOBHUdY.png');


                    // img 展示
                    $.each(art, function(index, values) {
                        var ImgHtml = `<div class="swiper-slide img-box">
                          <img src="${values.thumbnail}">
                        </div>`;
                        $('.slideImgBox-box').append(ImgHtml);
                    });


                    // $.each(video, function(index, values) {
                    //     var videoHtml = `<div class="swiper-slide videos-box" data="${values.video_link}">
                    //                     <a href="javascript:;"><img src="${values.thumbnail}"></a>
                    //                   </div>`;
                    //     $('.slideImgBox-box').append(videoHtml);
                    // })

                    // 综合新闻
                    // $.each(zonghe, function(index, values) {
                    //     var zongheHtml = `<li>
                    //         <a href="news-details-mobile.html?id=${values.id}">
                    //             <h2>${values.article_title}</h2>
                    //             <p>${values.article_excerpt}</p>
                    //             <span>${values.created_at}</span>
                    //         </a>
                    //     </li>`;;
                    //     $('.zonghe').append(zongheHtml);
                    // });

                    // // 活动新闻
                    // $.each(activity, function(index, values) {
                    //     var activityHtml = `<li>
                    //         <a href="news-details-mobile.html?id=${values.id}">
                    //             <h2>${values.article_title}</h2>
                    //             <p>${values.article_excerpt}</p>
                    //             <span>${values.created_at}</span>
                    //         </a>
                    //     </li>`;
                    //     $('.activity').append(activityHtml);
                    // });

                    // 集结
                    // jijie
                    // $.each(jijie, function(index, values) {
                    //     var jijieHtml = `<div class="other-inf">
                    //         <a href="drawing-details-mobile.html?article=${values.id}"><i></i></a>
                    //         <div class="banner">
                    //             <img src="${values.thumbnail}">
                    //         </div>
                    //         <div class="botton-inf">
                    //             <span>
                    //                 <h4>${values.origin}</h4>
                    //                 <p><b>${values.article_title}</b></p>
                    //             </span>
                    //         </div>
                    //     </div>`;
                    //     $('.other-wrap').append(jijieHtml);
                    // });

                    // 漫画3则
                    // console.log(cartoon.length);
                    // console.log(video);
                    // console.log(cartoon[0].thumbnail);
                    // if (cartoon.length >= 3) {
                    //     $('.cartoon-ul .li-01').find('img').attr('src', cartoon[0].thumbnail).attr('data', cartoon[0].video_link);
                    //     $('.cartoon-ul .li-02').find('img').attr('src', cartoon[1].thumbnail).attr('data', cartoon[1].video_link);
                    //     $('.cartoon-ul .li-04').find('img').attr('src', cartoon[2].thumbnail).attr('data', cartoon[2].video_link);
                    // }
                    // // console.log(video[0]);
                    // if (video.length !== 0) {
                    //     // 视频添加
                    //     $('.cartoon-ul .li-01').find('img').attr('src', video[0].thumbnail).attr('data', video[0].video_link);
                    //     $('.cartoon-ul .li-02').find('img').attr('src', video[1].thumbnail).attr('data', video[1].video_link);
                    //     $('.cartoon-ul .li-03').find('img').attr('src', video[2].thumbnail).attr('data', video[2].video_link);
                    //     $('.cartoon-ul .li-04').find('img').attr('src', video[3].thumbnail).attr('data', video[3].video_link);
                    // }

                    // // 最新新闻
                    // $.each(video, function(index, values) {
                    //     var videoHtml = `<div class="swiper-slide" 
                    //     data="${values.video_link}">
                    //     <a href="javascript:;">
                    //     <div>
                    //     <p>The super snail is scheduled to start on June 23 start on .</p>
                    //     </div>
                    //     <img src="${values.thumbnail}">
                    //     </a></div>`;
                    //     $('.swiper-container-video .slideTxtBox-box').append(videoHtml);
                    // });

                    // // 新闻标题限制字数
                    // $('.swiper-container-video .slideTxtBox-box p').each(function() {
                    //     if ($(this).text().length > 50) {
                    //         var str = $(this).text();
                    //         $(this).text(str.substr(0, 50) + '...');
                    //     }
                    // });

                    // 新闻标题限制字数


                    _this.indextabNews(); //新闻轮播
                    _this.maxLength(".swiper-container-new .slideTxtBox-box p", 50);
                    _this.Textlength(28, 25);
                    //Media轮播
                    _this.mediaSwiper();


                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        // $.ajax({
        //     url: "https://api.qcplay.com/web/news/info",
        //     type: "GET",
        //     xhrFields: {
        //         withCredentials: true
        //     },
        //     success: function(json) {
        //         var article = json.data.article;
        //         if (json.code == 200) {
        //             // 游戏资讯页-顶部
        //             $('.content-02 .banner a, .content-06 .top-link a').remove();
        //             $.each(article.game_information, function(index, values) {
        //                 var gameInfo = '<a href="' + values.jump_url + '"><img src="' + values.image + '"></a>';
        //                 $('.content-02 .banner').append(gameInfo);
        //             });

        //             // 同人专区页---公益活动
        //             $.each(article.recommend, function(index, values) {
        //                 var artRecommend = '<a href="' + values.jump_url + '" target="_blank"><img src="' + values.image + '"></a>';
        //                 $('.content-06 .top-link').append(artRecommend);
        //             });
        //         } else {
        //             layer.msg("Server not available", { time: 2000 });
        //         }

        //     },
        //     error: function() {
        //         layer.msg("Server not available", { time: 2000 });
        //     },
        //     complete: function() {
        //         layer.close(index);
        //     }
        // })
    },
    // 首页轮播
    indexSwiper: function() {
        function pageSwiper() {
            var mySwiper = new Swiper('.swiper-container', {
                pagination: '.swiper-pagination',
                direction: 'vertical',
                slidesPerView: 'auto',
                paginationClickable: true,
                spaceBetween: 0,
                initialSlide: initialSlide,
                mousewheelControl: true,
                resistanceRatio: 0,
                onInit: function(swiper) {
                    swiperAnimate(swiper);
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                    swiper.activeIndex >= 4 ? $('.rocket').fadeIn() : $('.rocket').fadeOut();
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
            });
            $('body').on('click', '.rocket', function(event) {
                var _this = $(this);
                _this.addClass('rocket-ani')
                mySwiper.slideTo(0, 1000, true);
                setTimeout(function() { _this.fadeOut() }, 1000);
                setTimeout(function() { _this.removeClass('rocket-ani') }, 1500);
            });
        }
        pageSwiper();


    },
    indextabNews() {
        setTimeout(function() {
            function tabNews() {
                var mySwiper = new Swiper('.swiper-container-new', {
                    loop: true,
                    effect: 'coverflow',
                    grabCursor: true,
                    centeredSlides: true,
                    nextButton: '.swiper-button-next',
                    prevButton: '.swiper-button-prev',
                    slidesPerView: 'auto',
                    // autoplay: 1000,
                    coverflow: {
                        rotate: 0, // 旋转的角度
                        stretch: 12.6, // 拉伸   图片间左右的间距和密集度
                        depth: 30, // 深度   切换图片间上下的间距和密集度
                        modifier: 10, // 修正值 该值越大前面的效果越明显
                        // slideShadows : false// 页面阴影效果
                    }
                });
            }
            tabNews()
        }, 100)
    },
    // 内容字体长度超过40，标题字体长度超过25
    Textlength: function(x1, x2) {
        $('.slideTxtBox .bd p').each(function() {
            if ($(this).text().length > x1) {
                var str = $(this).text();
                $(this).text(str.substr(0, x1) + '...');
            }
        });
        $('.slideTxtBox .bd h2').each(function() {
            if ($(this).text().length > x2) {
                var str = $(this).text();
                $(this).text(str.substr(0, x2) + '...');
            }
        });
    },
    // 字数限制
    maxLength: function(x, y) {
        $(x).each(function() {
            if ($(this).text().length > y) {
                var str = $(this).text();
                $(this).text(str.substr(0, y) + '...');
            }
        });
    },
    // 隐藏导航
    hiddenNav: function() {
        // 隐藏导航
        $('.screen_more').on('click', function() {
            $('.screen-popup').fadeOut();
        });
    },
    // 获取当前hash的具体参数
    getQueryVariable: function(variable) {
        var query = window.location.href.split('?')[1];
        var vars = query.split("&");
        for (var i = 0; i < vars.length; i++) {
            var pair = vars[i].split("=");
            if (pair[0] == variable) { return pair[1]; }
        }
        return (false);
    },
    // 最新、综合、活动跳转
    newsTabPage: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?cate_id=' + cate_id + '&page=1'
        });
    },
    // 新闻列表接口
    newsZxList: function(urls) {
        let cate_id = this.getQueryVariable('cate_id');
        let page = this.getQueryVariable('page');
        var current = window.location.href.split("?")[0];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax(urls) {
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                    area_id: 2
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        if (cate_id == 1) {
                            var current_page = json.data.new_list.current_page; // 当前页数
                            var last_page = json.data.new_list.last_page; // 总共页数
                            var next_page_url = json.data.new_list.next_page_url; // 后一页
                            // 渲染列表
                            $.each(json.data.new_list.data, function(index, values) {
                                var dtHtml = `<li>
                                    <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <span>${values.release_time}</span>
                                    </a>
                                </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });

                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html("You've reached the end!"); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url.split("west")[1]);
                            }
                        } else if (cate_id == 2) {
                            var current_page = json.data.new_general.current_page; // 当前页数
                            var last_page = json.data.new_general.last_page; // 总共页数
                            var next_page_url = json.data.new_general.next_page_url; // 后一页
                            // 渲染列表
                            $.each(json.data.new_general.data, function(index, values) {
                                var dtHtml = `<li>
                                    <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <span>${values.release_time}</span>
                                    </a>
                                </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });

                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html("You've reached the end!"); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url.split("west")[1]);
                            }
                        } else {
                            var current_page = json.data.new_event.current_page; // 当前页数
                            var last_page = json.data.new_event.last_page; // 总共页数
                            var next_page_url = json.data.new_event.next_page_url; // 后一页
                            // 渲染列表
                            $.each(json.data.new_event.data, function(index, values) {
                                var dtHtml = `<li>
                                    <a title="${values.article_title}" href="news-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <span>${values.release_time}</span>
                                    </a>
                                </li>`;
                                $('.list-wrap ul').append(dtHtml);
                            });
                            $('.current_page').html(current_page); // 当前页数
                            $('.last_page').html(last_page); // 总共页数
                            if (next_page_url === null) { // 下一页
                                $('.more-btn a').attr('data', '').html("You've reached the end!"); // 没有最后一页
                            } else {
                                page++
                                $('.more-btn a').attr('data', next_page_url.split("west")[1]);
                            }

                            // $('.current_page').html(current_page); // 当前页数
                            // $('.last_page').html(last_page); // 总共页数
                            // if (next_page_url == null) { // 下一页
                            //     $('.more-btn a').attr('data', '').html("You've reached the end!"); // 没有最后一页
                            // } else {
                            //     $('.more-btn a').attr('data', next_page_url).html('READ MORE');;
                            // }
                        }

                        // else {
                        //     $('.more-btn a').attr('data', '').html(''); // 没有最后一页
                        // }
                    } else {
                        layer.msg("Server not available", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("Server not available", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);

        $('.more-btn').on('click', 'a', function(event) {
            var page_data = $(this).attr('data');
            if (page_data == '') {
                layer.msg("You've reached the end!", { time: 2000 });
            } else {
                // page++
                index = layer.load(2, { shade: [0.1, '#fff'] });
                setTimeout(function() {
                    urls = '//api.qingcigame.com/west/new/list';
                    // console.log(urls);
                    newsAjax(urls);
                }, 100);
            }
        });
        for (var i = $('.link-box-02 div a').length; i >= 1; i--) {
            if (cate_id == i) $('.link-box-02 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 新闻详情
    newsInfo: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            // url: "https://api.qcplay.com/web/article/" + id + "",
            url: "//api.qingcigame.com/west/new/details",
            type: "GET",
            data: {
                area_id: 2,
                id: id
            },
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.current_page[0].article_title; // 标题
                    var detailsInfo = json.data.current_page[0].article_content; // 内容
                    // var origin = json.data.list.origin; // 作者
                    var created_at = json.data.current_page[0].release_time; // 时间

                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    // $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    // 翻页功能
                    obj.pageDown(json.data.previous_page, json.data.next_page, 'id');
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 翻页功能
    pageDown: function(lastPage, nextPage, cite) {
        var href = window.location.href.split("?")[0] + '?' + cite + '=';
        // console.log(href)
        // console.log(lastPage);
        // console.log(nextPage);

        if (lastPage.length !== 0) $('.prev-page').addClass('show').attr('href', href + lastPage[0].id).attr('title', lastPage.article_title);
        if (nextPage.length !== 0) $('.next-page').addClass('show').attr('href', href + nextPage[0].id).attr('title', nextPage.article_title);
    },
    // 视频切换
    videoSwitch: function() {
        $('.all-list').on('click', 'li', function(event) {
            $(this).addClass('on').siblings('a').removeClass('on');
            var cate_id = $(this).attr('cate-id');
            window.location.href = window.location.href.split("?")[0] + '?id=' + cate_id
        });
    },
    // 新闻列表接口
    newsIntrList: function(urls) {
        var cate_id = this.getQueryVariable('cate_id');
        var page = this.getQueryVariable('page');
        var current = window.location.href.split("?")[0];
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + cate_id + '').addClass('on').siblings().removeClass('on');

        function newsAjax() {
            // console.log('urls-----------', urls)
            $.ajax({
                url: urls,
                type: "GET",
                data: {
                    // cate_id 最新-综合-活动
                    // page    1...
                    cate_id: cate_id,
                    page: page,
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var current_page = json.data.articleList.current_page; // 当前页数
                        var last_page = json.data.articleList.last_page; // 总共页数
                        var next_page_url = json.data.articleList.next_page_url; // 后一页
                        // 渲染列表
                        $.each(json.data.articleList.data, function(index, values) {
                            var dtHtml = `<li>
                                    <a title="${values.article_title}" href="wiki-details-mobile.html?id=${values.id}">
                                        <h2>${values.article_title}</h2>
                                        <p>${values.article_excerpt}</p>
                                        <span>${values.created_at}</span>
                                    </a>
                                </li>`;
                            $('.list-wrap ul').append(dtHtml);
                        });
                        $('.current_page').html(current_page); // 当前页数
                        $('.last_page').html(last_page); // 总共页数
                        if (next_page_url === null) { // 下一页
                            $('.more-btn a').attr('data', '').html("You've reached the end!"); // 没有最后一页
                        } else {
                            $('.more-btn a').attr('data', next_page_url);
                        }
                    } else {
                        layer.msg("Server not available", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("Server not available", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        }
        newsAjax(urls);
        $('.more-btn').on('click', 'a', function(event) {
            if ($(this).attr('data') == '') {
                layer.msg("You've reached the end!", { time: 2000 });
            } else {
                urls = $(this).attr('data');
                newsAjax(urls);
            }
        });

        // 导航变色
        if (cate_id == 1) $('.link-box-03 div a:nth-child(1)').addClass('on');
        if (cate_id == 9) $('.link-box-03 div a:nth-child(2)').addClass('on');
        if (cate_id == 19) $('.link-box-03 div a:nth-child(4)').addClass('on');
    },
    // 获取视频中心视频
    videoCenterAjax: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $('.li-tab-0' + id + '').addClass('on').siblings().removeClass('on');

        // 全部视频
        $.ajax({
            url: "https://api.qcplay.com/web/article?cate_id=" + id + "&limit=0",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    if (id == 13) {
                        // 渲染漫画
                        $.each(json.data.articleList, function(index, values) {
                            var dtHtml = `<li><a href="cartoon-details-mobile.html?id=${values.id}">${values.article_title}</a></li>`;
                            $('.cartoon-list ul').append(dtHtml);
                        });
                    } else {
                        // 渲染视频数量
                        $.each(json.data.articleList, function(index, values) {
                            var dtHtml = `<li>
                                <dl>
                                    <dt>
                                        <a href="video-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"></a>
                                    </dt>
                                    <dd>${values.article_title}</dd>
                                </dl>
                            </li>`;
                            $('.video-list ul').append(dtHtml);
                        });
                    }
                    $('.s-title span').html('（连载至第' + parseInt(json.data.articleList.length) + '话）');
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        for (var i = $('.link-box-04 div a').length; i >= 1; i--) {
            if (id == 1 + '' + i + '') $('.link-box-04 div a:nth-child(' + i + ')').addClass('on');
        };
    },
    // 获取详细视频
    videoDetailsAjax: function() {
        var id = this.getQueryVariable('id');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qcplay.com/web/article/" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {

                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    var video_link = json.data.list.video_link; // 视频
                    $('.news-title, .current-title').html(newsTitle);
                    $('.details-info').append(detailsInfo);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.details-info video').attr('src', video_link);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'id');
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 同人区
    worksAjax: function() {
        var id = this.getQueryVariable('id');
        $('.li-tab-0' + id + '').addClass('on').siblings().removeClass('on');

        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qcplay.com/web/article?cate_id=" + id + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    $.each(json.data.articleList.data, function(index, values) {
                        var dtHtml = `<li class="article">
                            <a href="drawing-details-mobile.html?article=${values.id}">
                                <img src="${values.thumbnail}">
                            </a>
                            <div class="pic_info" >
                                <div class="txt_info">
                                    <p class="pic_name" title="${values.article_title}">${values.article_title}</p>
                                    <div class="author_name">
                                        <span>${values.origin}</span>
                                    </div>
                                </div>
                                <div class="hot_level">
                                    <em></em>
                                    <span>${values.like_num}</span>
                                </div>
                            </div>
                        </li>`;
                        // 渲染后 瀑布流
                        $('.wall').append(dtHtml).jaliswall({ item: '.article' });
                        $('.pager-more').fadeIn();
                    });
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        if (id == 15) $('.link-box-05 div a:nth-child(1)').addClass('on');
        if (id == 16) $('.link-box-05 div a:nth-child(2)').addClass('on');
    },
    // 同人专区-作品详情
    drawingInfo: function() {
        var article = this.getQueryVariable('article');
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        $.ajax({
            url: "https://api.qcplay.com/web/article/" + article + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    var newsTitle = json.data.list.article_title; // 标题
                    var detailsInfo = json.data.list.article_content; // 内容
                    var origin = json.data.list.origin; // 作者
                    var created_at = json.data.list.created_at; // 时间
                    var like_num = json.data.list.like_num; // 点赞
                    var video_link = json.data.list.video_link; // 视频

                    // 如果内容是空则为视频-否则默认新闻输出
                    if (detailsInfo == '') {
                        $('.details-info div').append('<video controls="controls" controlslist="nodownload" src="' + video_link + '" width="100%" height="100%" disablepictureinpicture="true" autoplay="autoplay" style="background-color: black;"></video>');
                    }
                    // 图片或者视频输出
                    $('.details-info div').append(detailsInfo);
                    $('.details-info').fadeIn();
                    $('.news-title, .current-title').html(newsTitle);
                    $('.origin').html(origin);
                    $('.created_at').html(created_at);
                    $('.btnVote').html(like_num);
                    // 翻页功能
                    obj.pageDown(json.data.last, json.data.next, 'article');
                } else {
                    layer.msg("Server not available", { time: 2000 });
                }

            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })

        // 点赞
        $('.btnVote').click(function(event) {
            $.ajax({
                url: "https://api.qcplay.com/web/article/?id=" + article + "",
                type: "POST",
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        $('.alert_box').fadeIn();
                        var number = Number($('.btnVote').html()) + 1;
                        $('.btnVote').html(number)
                    } else {
                        layer.msg("Server not available", { time: 2000 });
                    }

                },
                error: function() {
                    layer.msg("Server not available", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })
        });

        // 关闭点赞提示框
        $('.alert_box .alertClose, .alert_box .btnsConfirm').click(function(event) {
            $('.alert_box').fadeOut();
        });
    },
    // media轮播
    mediaSwiper: function() {
        function tabSwiperOne() {
            // media上半部分swiper初始化
            var swiper2 = new Swiper('.swiper-container2', {
                pagination: '.swiper-pagination',
                paginationClickable: true,
                spaceBetween: 10,
                speed: 300,
                onInit: function(swiper) {
                    swiperAnimate(swiper);

                    function Ani(btn, page) {
                        $(btn).on('click', function() {
                            // 上面轮播移动到当前图
                            swiper2.slideTo(page - 1, 300, true);
                            // 获取切换后当前图片的路径对应下半部分是第几个
                            var imgSrc = $('.art img').attr('src');
                            var videoSrc = $('.videos img').attr('src');

                            // 底部swiper移动到最开始位置
                            pageIndex = page;
                            // if (page == 2) {
                            //     $('.slideImgBox-box').empty();
                            //     $.each(videoList, function(index, values) {
                            //         if (values.thumbnail === videoSrc) videoIndex = index
                            //         var videoHtml = `<div class="swiper-slide videos-box" data="${values.video_link}">
                            //       <a href="javascript:;"><img src="${values.thumbnail}"></a>
                            //     </div>`;
                            //         $('.slideImgBox-box').append(videoHtml);
                            //     });
                            // }
                            if (page == 2) {
                                $('.slideImgBox-box').empty();
                                // 视频合集暂未开放
                                var nVideoList = [{
                                        "thumbnail": 'https://download4.qcplay.com/qcgame-admin/TvjMu5U715JlCqsQgJukLapqXhakTxoY4GOBHUdY.png'
                                    },
                                    {
                                        "thumbnail": 'https://download4.qcplay.com/qcgame-admin/TvjMu5U715JlCqsQgJukLapqXhakTxoY4GOBHUdY.png'
                                    },
                                    {
                                        "thumbnail": 'https://download4.qcplay.com/qcgame-admin/TvjMu5U715JlCqsQgJukLapqXhakTxoY4GOBHUdY.png'
                                    },
                                    {
                                        "thumbnail": 'https://download4.qcplay.com/qcgame-admin/TvjMu5U715JlCqsQgJukLapqXhakTxoY4GOBHUdY.png'
                                    }
                                ]
                                $.each(nVideoList, function(index, values) {
                                    if (values.thumbnail === videoSrc) videoIndex = index
                                    var videoHtml = `<div class="swiper-slide videos-box">
                                  <img src="${values.thumbnail}">
                                </div>`;
                                    $('.slideImgBox-box').append(videoHtml);
                                });
                            } else {
                                $('.slideImgBox-box').empty();
                                $.each(artList, function(index, values) {
                                    if (values.thumbnail === imgSrc) imgIndex = index
                                    var ImgHtml = `<div class="swiper-slide img-box">
                                  <img src="${values.thumbnail}">
                                </div>`;
                                    $('.slideImgBox-box').append(ImgHtml);
                                });
                            }
                            // 销毁底部swiper重新创建, 更新底部轮播图
                            swiper4.destroy(true, true)
                            tabSwiperTwo();
                        });
                    };

                    function navLink() {
                        for (var i = 2; i >= 1; i--) {
                            Ani('.tit-li-0' + i + '', i);
                        };
                    }
                    navLink();
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                    $('.tit-ul li').removeClass('on');
                    $('.tit-li-0' + Number(swiper.activeIndex + 1) + '').addClass('on');
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
            });
        }
        tabSwiperOne();

        function tabSwiperTwo() {
            // media下半部分swiper初始化
            swiper4 = new Swiper('.swiper-container-img', {
                loop: true,
                spaceBetween: 5.66,
                loopedSlides: 7,
                slidesPerView: 3,
                observer: true, //当改变swiper的样式（例如隐藏/显示）或者修改swiper的子元素时，自动初始化swiper
                speed: 300,
                nextButton: '.swiper-button-next2',
                prevButton: '.swiper-button-prev2',
                onInit: function(swiper) {
                    swiper.slideTo(pageIndex === 1 ? imgIndex : videoIndex, 0, true);

                    // 当轮播点击的时候做的操作
                    $(".img-box img").on('click', function(event) {
                        var _this = $(this);
                        var dataSrc = _this.attr('src');
                        // 替换上半部分显示的图的路径
                        $('.art img').attr("src", dataSrc);
                    })

                    // 开放视频
                    // $(".videos-box img").on('click', function(event) {
                    //     var data = $(this).parent().parent().attr('data');
                    //     var _this = $(this);
                    //     var dataSrc = _this.attr('src');
                    //     // 替换上半部分显示的图的路径以及播放路径
                    //     $('.videos img').attr("src", dataSrc);
                    //     $('.videos a').attr("data", data);
                    // })

                    // 暂未开放视频
                    $(".videos-box img").on('click', function(event) {
                        layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
                    })
                },
                onSlideChangeEnd: function(swiper) {
                    swiperAnimate(swiper);
                },
                onTouchEnd: function(swiper) {
                    swiperAnimate(swiper);
                },

            });
        }
        tabSwiperTwo();
    },
    // 贵重品展示
    wikiShow: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        var limit = 12; // 贵重品个数12个
        var _this = this;
        $.ajax({
            url: 'https://api.qingcigame.com/west/goods' + "?limit=" + limit + "",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                if (json.code == 200) {
                    function resetSet(li) {
                        $(li).find('li').removeClass('on');
                    }

                    $('.goods-list-wrap ul').find('li').remove();
                    if (json.data.data.data == '') {
                        layer.msg("Relic not found", { time: 2000 });
                        $('.tips-wrap').fadeIn();
                    } else {
                        $.each(json.data.data.data, function(index, values) {
                            var addHtml = `<li class="li-color-0${values.colour}"
                              titles="${values.name_es}"
                              colour="${values.colour}"
                              art="${values.art}"
                              culture="${values.culture}"
                              describe="${values.describe_es}"
                              deviation="${values.deviation}"
                              faith="${values.faith}"
                              get_type="${values.get_type}"
                              halo_effect="${values.halo_effect}"
                              id="${values.icon_id}"
                              mosaic_skill="${values.mosaic_skill}"
                              popularity="${values.popularity}"
                              quality="${values.quality}"
                              rarity="${values.rarity_es}"
                              rarity_order="${values.rarity_order}"
                              technology="${values.technology}">
                              <div class='text'><p></p></div>
                              <img src="https://download4.qcplay.com/qcgame-admin/EuropeAmerica/${values.icon_id}.png">
                              </li>`;
                            $('.goods-list .goods').append(addHtml);
                        });
                        $.each(json.data.data.data, function(index, values) {
                            var addHtml = `<li titles="${values.name_es}">
                            <div class="g-title"><p>${values.name_es}</p></div>
                            </li>`;
                            $('.goods-list .goods-title').append(addHtml);
                        });
                        $('.tips-wrap').hide();
                    }
                }
            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // wiki轮播
    wikiSwiper: function() {
        var swiper2 = new Swiper('.swiper-container2', {
            pagination: '.swiper-pagination',
            paginationClickable: true,
            spaceBetween: 50,
            speed: 300,
        });
    },
    wikiIndexAjax: function() {
        var index = layer.load(2, { shade: [0.1, '#fff'] });
        var _this = this;
        $.ajax({
            url: "https://api.qcplay.com/web/getdata",
            type: "GET",
            xhrFields: {
                withCredentials: true
            },
            success: function(json) {
                var banner = json.data.articleList.banner; // 地图探索
                var ditu = json.data.articleList.ditu; // 地图探索
                var hot = json.data.articleList.hot; // 热门
                var xinshou = json.data.articleList.xinshou.data; // 新手
                var xingtai = json.data.articleList.xingtai; // 形态
                var index = json.data.articleList.index; // 热门
                if (json.code == 200) {
                    // // 渲染-地图探索
                    $.each(banner, function(index, values) {
                        var addHtml = `<div class="swiper-slide">
                            <a href="${values.url}">
                                <img src="${values.mobile_background}">
                            </a>
                        </div>`;
                        $('.swiper-container2 .swiper-wrapper').append(addHtml);
                    });
                    _this.wikiSwiper();
                    $('.swiper-container2 .swiper-slide:nth-child(1)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=9&page=1');
                    $('.swiper-container2 .swiper-slide:nth-child(2)').find('a').attr('href', 'wiki-precious-mobile.html');
                    $('.swiper-container2 .swiper-slide:nth-child(3)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=17&page=1');

                    // // 渲染-地图探索
                    $.each(ditu, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span></span></a></li>`;
                        $('.map-exploration ul').prepend(addHtml);
                    });

                    $('.map-exploration li:nth-child(1)').find('span').html('高丽');
                    $('.map-exploration li:nth-child(2)').find('span').html('扶桑');
                    $('.map-exploration li:nth-child(3)').find('span').html('华夏');
                    $('.map-exploration li:nth-child(4)').find('span').html('米国');
                    $('.map-exploration li:nth-child(5)').find('span').html('英伦');

                    // // 渲染-热门
                    $.each(hot, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}">${values.article_title}</a></li>`;
                        $('.hot-pages .list ul').append(addHtml);
                    });
                    // // 新手指南
                    for (var i = $('.novice-guide li').length - 1; i >= 0; i--) {
                        // console.log(xinshou[i].id)
                        $('.novice-guide .li-0' + i + ' a').attr('href', 'wiki-details-mobile.html?id=' + xinshou[i].id + '');
                    };

                    // // 渲染-形态
                    $.each(xingtai, function(index, values) {
                        var addHtml = `<li><a href="wiki-details-mobile.html?id=${values.id}"><img src="${values.thumbnail}"><span>${values.cate_id}</span></a></li>`;
                        $('.form-intr ul').prepend(addHtml);
                    });

                    // 先固定写死
                    $('.form-intr ul li:nth-child(1)').find('span').html('活尸');
                    $('.form-intr ul li:nth-child(2)').find('span').html('恶魔');
                    $('.form-intr ul li:nth-child(3)').find('span').html('天使');
                    $('.form-intr ul li:nth-child(4)').find('span').html('机械');
                    $('.form-intr ul li:nth-child(5)').find('span').html('异种');
                    $('.form-intr ul li:nth-child(6)').find('span').html('巨龙');

                    // // // 渲染-wiki-镶嵌技能的参数
                    // $.each(index, function(index, values) {
                    //     var addHtml = `<li><a href="wiki-details.html?id=${values.id}"><span>${values.cate_id}</span><p>${values.article_title}</p></a></li>`;
                    //     $('.game-intr ul').append(addHtml);
                    // });
                    // $('.halo_effect, .mosaic_skill').find('li:nth-child(1)').addClass('on').attr('data', '');

                } else {
                    layer.msg("Server not available", { time: 2000 });
                }
            },
            error: function() {
                layer.msg("Server not available", { time: 2000 });
            },
            complete: function() {
                layer.close(index);
            }
        })
    },
    // 获取需要筛选的wiki参数
    // getWikiData: function() {
    //     var index = layer.load(2, { shade: [0.1, '#fff'] });
    //     $.ajax({
    //         url: "https://api.qingcigame.com/west/get_type",
    //         type: "GET",
    //         xhrFields: {
    //             withCredentials: true
    //         },
    //         success: function(json) {
    //             if (json.code == 200) {
    //                 // 渲染-wiki-光环技能的参数
    //                 // $.each(json.data.data.halo_effect, function(index, values) {
    //                 //     var addHtml = `<li data="${values}">${values}</li>`;
    //                 //     $('.halo_effect').append(addHtml);
    //                 // });

    //                 // 渲染-wiki-镶嵌技能的参数
    //                 // $.each(json.data.data.mosaic_skill, function(index, values) {
    //                 //     var addHtml = `<li data="${values}">${values}</li>`;
    //                 //     $('.mosaic_skill').append(addHtml);
    //                 // });
    //                 $('.halo_effect, .mosaic_skill').find('li:nth-child(1)').addClass('on').attr('data', '');
    //             } else {
    //                 layer.msg("Server not available", { time: 2000 });
    //             }

    //         },
    //         error: function() {
    //             layer.msg("Server not available", { time: 2000 });
    //         },
    //         complete: function() {
    //             layer.close(index);
    //         }
    //     })
    // },
    wikibind: function() {
        $('.screen_more').on('click', function(event) {
            if (change == true) {
                $('.nav-wrap').fadeIn()
                $('.nav-popup').addClass('nav-popup-show');
                change = false;
            } else {
                $('.nav-wrap').fadeOut()
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
        });
        $('.nav-wrap,.confirm-btn').on('click', function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.nav-wrap').fadeOut();
                $('.nav-popup').removeClass('nav-popup-show');
                change = true;
            }
        })
    },
    // 贵重物品弹窗内信息切换-关闭弹窗清除数据
    wikiTabInfo: function() {
        $('.wiki-wrap .tit').on('click', 'li', function(event) {
            $(this).addClass('on').siblings().removeClass('on').parent('.tit').siblings('.con').children('div').eq($(this).index()).addClass('show').siblings().removeClass('show');
        });
    },
    // 贵重物品弹窗
    wikiPopup: function() {
        // 开启弹窗
        $('.goods-list-wrap,.goods-list').on('click', 'li', function(event) {
            $('.wiki-popup').fadeIn();

            var title = $(this).attr('titles'); // 标题
            var colour = $(this).attr('colour'); // 颜色
            var art = $(this).attr('art'); // 艺术
            var culture = $(this).attr('culture'); // 文化
            var describe = $(this).attr('describe'); // 简介
            var deviation = $(this).attr('deviation'); // 偏向
            var faith = $(this).attr('faith'); // 信仰
            var get_type = $(this).attr('get_type'); // 获取途径
            var halo_effect = $(this).attr('halo_effect'); // 光环技能
            var id = $(this).attr('id'); // 图片id
            var mosaic_skill = $(this).attr('mosaic_skill'); // 镶嵌技能
            var popularity = $(this).attr('popularity'); // 人气
            var quality = $(this).attr('quality');
            var rarity = $(this).attr('rarity');
            var rarity_order = $(this).attr('rarity_order');
            var technology = $(this).attr('technology'); // 科技


            if (halo_effect == '') halo_effect = 'halo_effect no data'
            if (mosaic_skill == '') mosaic_skill = 'mosaic_skill no data'
            if (get_type == '') get_type = 'get_type no data'
            if (describe == '') describe = 'describe no data'
            if (faith == '') faith = 'faith no data'
            if (deviation == '') deviation = 'deviation no data'

            // 技能按钮 (保留 暂时不用)
            // var skillHtml1 = `<li class="s-01"
            // describe="${faith}">
            // <img src="/official/images/mobile/wiki/skill_01-822291b2dc.png">
            // </li>`;
            // $('.skill-btn').append(skillHtml1);


            // var skillHtml2 = `<li class="s-02"
            // describe="${mosaic_skill}">
            // <img src="/official/images/mobile/wiki/skill_02-00028be797.png">
            // </li>`;
            // $('.skill-btn').append(skillHtml2);


            // var skillHtml3 = `<li class="s-03"
            // describe="${get_type}">
            // <img src="/official/images/mobile/wiki/skill_03-985b9f60b8.png">
            // </li>`;
            // $('.skill-btn').append(skillHtml3);

            // function skillBox(btn) {
            //     $('.p-01').html('')
            //     $(btn).on('click', function() {
            //         var describe = $(this).attr('describe')
            //         $('.p-01').html(describe)
            //     })
            // }

            // function navSkill() {
            //     for (var i = 1; i <= 3; i++) {
            //         skillBox('.s-0' + i + '')
            //     }
            // }
            // navSkill();

            $('.tit-li-01').on('click', function(event) {
                $('.wiki-wrap .p-01').html(halo_effect); // 第一个按钮
            });

            $('.tit-li-02').on('click', function(event) {
                $('.wiki-wrap .p-01').html(deviation); // 第二个按钮
            });

            // 品阶 无则不输出且移除 有则添加
            rarity == '无' ? (rarity = '', $('.wiki-wrap .goods-info .pj').remove()) : $('.wiki-wrap .goods-info .pj').addClass(rarity);


            $('.wiki-wrap .goods-info p').html(title); // 标题
            $('.wiki-wrap .span-pj').html(quality + rarity); // 颜色
            $('.wiki-wrap .span-px').html(deviation); // 偏向

            $('.wiki-wrap .pic-img img').attr('src', '//download4.qcplay.com/qcgame-admin/EuropeAmerica/' + id + '.png')
            $('.wiki-wrap .pic-img').addClass('pic-img-0' + colour + ''); // 框框颜色
            $('.wiki-wrap .goods-info').addClass('info-img-0' + colour + ''); // 标题底板颜色
            $('.wiki-wrap .goods-info p').addClass('font-0' + colour + ''); // 标题文字颜色
            $('.wiki-wrap .pic-img .star-level').addClass('l-' + colour + ''); // 星级

            $('.wiki-wrap .form p').html(halo_effect); // 光环技能
            $('.wiki-wrap .p-01').html(describe); // 简介

            // $('.wiki-wrap .p-02').html(mosaic_skill); // 镶嵌技能
            // $('.wiki-wrap .p-03').html(get_type); // 镶嵌技能
            // $('.wiki-wrap .p-04').html(describe); // 简介

            if (colour == 1) colour = '#f9ab61', tColor = '#9c6e58';
            if (colour == 2) colour = '#81c9d4', tColor = '#678b9c';
            if (colour == 3) colour = '#9cbd56', tColor = '#78875b';
            if (colour == 4) colour = '#DCA8C7', tColor = '#a9819f';
            $('.wiki-wrap .form p').css("color", tColor); // 文本颜色

            myChart(popularity, art, faith, culture, technology, colour);
        });

        // 关闭弹窗
        $('.popup_wrap').on('click', function(event) {
            if ($(event.target)[0] == $(this)[0]) {
                $('.popup_wrap').fadeOut();
                setTimeout(function() {
                    // $('.skill-btn li').remove(); 暂时隐藏
                    for (var i = 4; i >= 0; i--) {
                        $('.wiki-wrap .pic-img').removeClass('pic-img-0' + i + ''); // 清空框框颜色
                        $('.wiki-wrap .goods-info').removeClass('info-img-0' + i + ''); // 清空标题底板颜色
                        $('.wiki-wrap .goods-info p').removeClass('font-0' + i + ''); // 清空标题文字颜色
                        $('.wiki-wrap .pic-img .star-level').removeClass('l-' + i + ''); // 清空星级
                    }

                    // 标题品阶
                    var pjHtml = '<div class="pj"></div>'
                    $('.wiki-wrap .goods-info').children().length == 2 ? $('.wiki-wrap .goods-info .pj').removeClass().addClass('pj') : $('.goods-info p').before(pjHtml);

                    $('.wiki-wrap .form p').css("color", ""); // 文本颜色
                    $('.wiki-wrap .pic-img img').attr('src', '');
                    $('.wiki-wrap h1, .wiki-wrap h2 span').html(''); // 清空标题/颜色
                    $('.wiki-wrap .con p').html(''); // 清空光环技能/镶嵌技能/镶嵌技能/简介
                    $('.wiki-wrap .data-ul li').html(''); // 清空/人气/艺术/信仰/文化/科技
                    $('.wiki-wrap .tit .tit-li-01').addClass('on').siblings().removeClass('on'); // tab恢复
                    $('.wiki-wrap .con div:nth-child(1)').addClass('show').siblings().removeClass('show'); // tab恢复
                }, 300)
            }
        });

        function myChart(popularity, art, faith, culture, technology, colour) {
            // console.log(colour)
            //指定图表的配置项和数据
            var option = {
                //标题
                title: {
                    text: null
                },
                tooltip: {},
                radar: {
                    center: ['50%', '60%'],
                    startAngle: 90,
                    name: {
                        formatter: '{value}',
                        textStyle: {
                            color: '#937f80',
                            fontSize: '9',
                            lineHeight: 9,
                            padding: [0, 0],
                            textAlign: 'center',
                        },
                        formatter: function(data, indicator) {
                            let data0 = data.substring(0, 4)
                            let data1 = data.substring(4)
                            if (data1 == maxData) indicator.nameTextStyle.color = colour
                            return data0 + '\n' + data1
                                // return val.split(":").join("\n");
                        },
                    },
                    // 指示器名称和指示器轴的距离。[ default: 5 ]
                    nameGap: 5,
                    // 雷达图圈数设置
                    splitNumber: 2,
                    // 设置雷达图中间射线的颜色
                    axisLine: {
                        lineStyle: {
                            width: 2,
                            color: '#ae988b',
                        },
                    },
                    splitArea: {
                        show: true,
                        areaStyle: {
                            color: '#deceb6', // 图表背景的颜色
                        },
                    },
                    splitLine: {
                        show: true,
                        lineStyle: {
                            width: 2,
                            color: '#ac998b', // 设置网格的颜色
                        },
                    },
                    indicator: [
                        { name: 'FAME' + popularity, max: 120 },
                        { name: 'TECH' + technology, max: 120 },
                        { name: 'CIV ' + culture, max: 120 },
                        { name: 'FTH ' + faith, max: 120 },
                        { name: 'ART ' + art, max: 120 },
                    ],
                    radius: 41
                },
                series: [{
                    type: 'radar',
                    itemStyle: { // 折线拐点标志的样式。
                        normal: { // 普通状态时的样式
                            lineStyle: {
                                width: 2,
                                color: colour,
                            },
                        },
                    },
                    data: [{
                        value: [popularity, technology, culture, faith, art],
                        itemStyle: { // 单个拐点标志的样式设置。
                            normal: {
                                color: 'rgba(60,135,213,.3)',
                                opacity: 0.2,
                                // 拐点的描边颜色。[ default: '#000' ]
                                borderWidth: 1,
                                // 拐点的描边宽度，默认不描边。[ default: 0 ]
                            }
                        },
                        areaStyle: {
                            normal: {
                                color: colour // 选择区域颜色
                            }
                        }

                    }, ],
                }]
            };
            var maxData = Math.max.apply(this, option.series[0].data[0].value)
                //获取dom容器
            var myChart = echarts.init(document.getElementById('chartmain'));
            // 使用刚指定的配置项和数据显示图表。
            myChart.setOption(option);
        }
    },
    // wiki-贵重物品-搜索
    wikiSearch: function() {
        var _this = this;
        $('.search-btn').on('click', function(event) {
            var searchIpu = $('.search-input').val()
            if (searchIpu == '') {
                layer.msg("请输入您需要搜索的名称", { time: 2000 });
                return
            }
            var index = layer.load(2, { shade: [0.1, '#fff'] });
            $.ajax({
                url: 'https://api.qingcigame.com/west/goods',
                type: "GET",
                data: {
                    title: searchIpu
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var next_page_url = json.data.data.next_page_url; // 下一页的数据
                        // 如果下页有参数则显示更多按钮
                        next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();

                        $('.search-input').val('') // 搜索完成后搜索栏目清空
                            // 清除信息
                        var gradeSet = resetSet('.grade');
                        var dimensionSet = resetSet('.dimension');
                        var halo_effectSet = resetSet('.halo_effect');
                        var mosaic_skillSet = resetSet('.mosaic_skill');
                        var grade_arraySet = resetSet('.grade_array');

                        function resetSet(li) {
                            $(li).find('li').removeClass('on');
                        }

                        $('.goods-list-wrap ul').find('li').remove();
                        if (json.data.data.data == '') {
                            layer.msg("Relic not found", { time: 2000 });
                            $('.tips-wrap').fadeIn();
                        } else {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}"
                                    titles="${values.name_es}"
                                    colour="${values.colour}"
                                    art="${values.art}"
                                    culture="${values.culture}"
                                    describe="${values.describe_es}"
                                    deviation="${values.deviation}"
                                    faith="${values.faith}"
                                    get_type="${values.get_type}"
                                    halo_effect="${values.halo_effect}"
                                    id="${values.icon_id}"
                                    mosaic_skill="${values.mosaic_skill}"
                                    popularity="${values.popularity}"
                                    quality="${values.quality}"
                                    rarity="${values.rarity_es}"
                                    rarity_order="${values.rarity_order}"
                                    technology="${values.technology}">
                                    <div>
                                    <img src="//download4.qcplay.com/qcgame-admin/EuropeAmerica/${values.icon_id}.png">
                                    </div>
                                    <span>${values.name_es}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            $('.tips-wrap').hide();
                        }
                    }
                },
                error: function() {
                    layer.msg("Server not available", { time: 2000 });
                },
                complete: function() {
                    layer.close(index);
                }
            })

        });
    },
    // wiki-贵重物品-筛选
    filtering: function() {
        let rarity = ''; // 品阶
        var deviation = ''; // 五围
        var halo_effect = ''; // 光环技能
        var mosaic_skill = ''; // 镶嵌技能
        var column = ''; // 筛选参数1
        var order = ''; // 筛选参数2
        var page = ''; // 第几页
        var url = 'https://api.qingcigame.com/west/goods'; // 需要请求的地址 //首次初始化暂时先开放50个

        // 第一次进入时候请求一次
        function wikiDataAjax(url) {
            $('.loading-wrap').fadeIn();
            $.ajax({
                url: url,
                type: "GET",
                data: {
                    rarity: rarity,
                    deviation: deviation,
                    halo_effect: halo_effect,
                    // mosaic_skill: mosaic_skill,
                    column: column,
                    order: order,
                    page: page
                },
                xhrFields: {
                    withCredentials: true
                },
                success: function(json) {
                    if (json.code == 200) {
                        var next_page_url = json.data.data.next_page_url; // 下一页的数据
                        // 渲染-所有贵重物品
                        // 橙色-1
                        // 蓝色-2
                        // 绿色-3
                        // 紫色-4
                        if (json.data.data.data.length !== 0) {
                            $.each(json.data.data.data, function(index, values) {
                                var addHtml = `<li class="li-color-0${values.colour}"
                                titles="${values.name_es}"
                                colour="${values.colour}"
                                art="${values.art}"
                                culture="${values.culture}"
                                describe="${values.describe_es}"
                                deviation="${values.deviation}"
                                faith="${values.faith}"
                                get_type="${values.get_type}"
                                halo_effect="${values.halo_effect}"
                                id="${values.icon_id}"
                                mosaic_skill="${values.mosaic_skill}"
                                popularity="${values.popularity}"
                                quality="${values.quality}"
                                rarity="${values.rarity_es}"
                                rarity_order="${values.rarity_order}"
                                technology="${values.technology}">
                                    <div>
                                    <img src="//download4.qcplay.com/qcgame-admin/EuropeAmerica/${values.icon_id}.png">
                                    </div>
                                    <span>${values.name_es}</span>
                                </li>`;
                                $('.goods-list-wrap ul').append(addHtml);
                            });
                            // 如果下页有参数则显示更多按钮
                            next_page_url !== null ? $('.more-wrap').fadeIn().attr('data', next_page_url) : $('.more-wrap').hide();
                            $('.tips-wrap, .loading-wrap').hide();
                        } else {
                            layer.msg("Relic not found", { time: 2000 });
                            $('.tips-wrap').fadeIn();
                        }
                        $('.loading-wrap').hide();
                    } else {
                        $('.loading-wrap').fadeIn().html('Server not available');
                    }

                },
                error: function() {
                    $('.loading-wrap').fadeIn().html('Server not available');
                },
                complete: function() {
                    // layer.close(index);
                }
            })
        }
        wikiDataAjax(url);

        // 点击选择按钮
        $('.link-box').on('click', 'li', function(event) {
            page = 1; // 每次点击按钮的时候回到第一页
            var _this = $(this);
            _this.addClass('on').siblings().removeClass('on');
            getLiData(); // 获取条件数据
            $('.goods-list-wrap ul').find('li').remove(); // 先清除一次再渲染
            wikiDataAjax(url); // 选择条件数据后ajax请求
        });

        // 关闭弹窗
        $('.screen-close').click(function(event) {
            $('.screen-popup').fadeOut();
            $('.bottom-nav li').removeClass('on');
        });


        // 点击更多查看下一页
        $('.more-wrap').click(function(event) {
            page = $(this).attr('data').split("?page=")[1];
            getLiData(); // 获取条件数据
            wikiDataAjax(url) // 选择条件数据后ajax请求
        });

        // 获取数据信息
        function getLiData() {
            rarity = $('.grade').find('.on').attr('data'); // 品阶
            deviation = $('.dimension').find('.on').attr('data'); // 五围
            halo_effect = $('.halo_effect').find('.on').attr('data'); // 光环技能
            mosaic_skill = $('.mosaic_skill').find('.on').attr('data'); // 镶嵌技能
            column = $('.grade_array').find('.on').attr('column'); // 筛选参数1
            order = $('.grade_array').find('.on').attr('order'); // 筛选参数2
        }

        // wiki-贵重物品-筛选-复位清除选项
        $('.reset-btn').click(function(event) {
            $('.goods-list-wrap ul').find('li').remove();
            $('.link-box ul li:nth-child(1)').addClass('on').siblings().removeClass('on');
            rarity = ''; // 品阶
            deviation = ''; // 五围
            halo_effect = ''; // 光环技能
            mosaic_skill = ''; // 镶嵌技能
            column = ''; // 筛选参数1
            order = ''; // 筛选参数2
            page = ''; // 第几页
            url = 'https://api.qingcigame.com/west/goods?limit=50'; // 需要请求的地址
            wikiDataAjax(url);

            $('.nav-wrap').fadeOut();
            $('.nav-popup').removeClass('nav-popup-show');
            change = true;
        });
    },
    // 地图探索弹窗
    mapPopup: function() {
        //开启弹窗
        $('.map-explore').on('click', 'li', function(event) {
            let id = $(this).attr("id");
            if ($(this).hasClass("light")) {
                $('.map-popup').fadeIn();
            } else if ($(this).hasClass("light-f")) {
                window.location.href = 'https://supersnail.fandom.com/wiki/SuperSnail_Wiki';
            } else {
                layer.msg("Coming soon. Please stay tuned!", { time: 2000 });
            }

            $('.map-popup .title').addClass("map-t-0" + id); // 标题
            $('.map-popup .content').addClass("map-c-0" + id); // 内容
        });

        // 关闭弹窗
        $('.map-popup').on('click', function(event) {
            $('.map-popup').fadeOut();
            $('.map-popup .title').attr("class", "title");
            $('.map-popup .content').attr("class", "content");
        });


        $('.map-explore li:nth-child(1)').find('a').attr('href', 'introduction-list-mobile.html?cate_id=17&page=1');
    },
    // 尾部分享
    footShare: function() {
        // 开启分享二维码弹窗
        $('.follow-btn').click(function(event) {
            $('.follow-popup').fadeIn();
        });

        // 关闭分享弹窗
        $('.close-bg').click(function(event) {
            $('.follow-popup, .share-popup').fadeOut();
        });

        // 开启分享链接弹窗
        $('.share-btn').click(function(event) {
            $('.share-popup').fadeIn();
        });
    },
    // 阻止默认页面弹起影响触摸位置
    preventInput: function() {
        $("input").blur(function() {
            setTimeout(function() {
                var scrollHeight = document.documentElement.scrollTop || document.body.scrollTop || 0;
                window.scrollTo(0, Math.max(scrollHeight - 1, 0));
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            }, 100);
        });
    },
    share: function() {
        $.ajax({
            url: api + "/wechat/jssdk",
            type: "POST",
            data: {
                uri: window.location.href,
            },
            success: function(json) {

                var ua = navigator.userAgent.toLowerCase();
                if (ua.match(/MicroMessenger/i) == "micromessenger") {
                    wx.config(json.data);
                    wx.ready(function() {
                        wx.updateAppMessageShareData({
                            title: '最强蜗牛', // 分享标题
                            desc: '大家都爱玩的沙雕手游', // 分享描述
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {}
                        })

                        wx.updateTimelineShareData({
                            title: '最强蜗牛-大家都爱玩的沙雕手游', // 分享标题
                            link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                            imgUrl: 'https://static.qcplay.com/common/snail_icon.png', // 分享图标
                            success: function() {
                                // 设置成功
                            }
                        })
                    });
                    return;
                } else {
                    try {
                        setShareInfo({
                            title: '最强蜗牛', // 分享标题
                            summary: '大家都爱玩的沙雕手游', // 分享内容
                            pic: 'https://static.qcplay.com/common/snail_icon.png', // 分享图片
                            url: window.location.href, // 分享链接
                            // 微信权限验证配置信息，若不在微信传播，可忽略
                            WXconfig: {
                                swapTitleInWX: true, // 是否标题内容互换（仅朋友圈，因朋友圈内只显示标题）
                                appId: json.data.appId, // 公众号的唯一标识
                                timestamp: json.data.timestamp, // 生成签名的时间戳
                                nonceStr: json.data.nonceStr, // 生成签名的随机串
                                signature: json.data.signature // 签名
                            }
                        });
                    } catch (err) {}
                }
            }
        })
    },
    urlAjax: function() {
        var facebookUrl = '//www.facebook.com/SuperSnailOfficial';
        var twitterUrl = '//twitter.com/SuperSnailUS';
        var youtubeUrl = '//www.youtube.com/@supersnailofficial';
        var redditUrl = '//www.reddit.com/r/SuperSnail_US/';
        var instagramUrl = '//www.instagram.com/supersnailofficial/';
        var discordUrl = '//discord.gg/supersnail';

        $('.facebook').attr('href', facebookUrl);
        $('.twitter').attr('href', twitterUrl);
        $('.youtube').attr('href', youtubeUrl);
        $('.reddit').attr('href', redditUrl);
        $('.instagram').attr('href', instagramUrl);
        $('.discord').attr('href', discordUrl);

    },
    // 阿里云埋点
    countNum: function(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e)
            }
        }, 500);
    }
}